import { useTranslation } from "react-i18next";

const useProductFeaturesData = () => {
  const { t } = useTranslation("productFeatures");

  const data = [
    {
      img: {
        src: "/images/productFeatures/product-feature-1.svg",
        alt: t("one.title")
      },
      title: t("one.title"),
      description: t("one.description")
    },
    {
      img: {
        src: "/images/productFeatures/product-feature-2.svg",
        alt: t("two.title")
      },
      title: t("two.title"),
      description: t("two.description")
    },
    {
      img: {
        src: "/images/productFeatures/product-feature-3.svg",
        alt: t("three.title")
      },
      title: t("three.title"),
      description: t("three.description")
    },
    {
      img: {
        src: "/images/productFeatures/product-feature-4.svg",
        alt: t("four.title")
      },
      title: t("four.title"),
      description: t("four.description")
    },
    {
      img: {
        src: "/images/productFeatures/product-feature-5.svg",
        alt: t("five.title")
      },
      title: t("five.title"),
      description: t("five.description")
    },
    {
      img: {
        src: "/images/productFeatures/product-feature-6.svg",
        alt: t("six.title")
      },
      title: t("six.title"),
      description: t("six.description")
    }
  ];

  return data;
};

export default useProductFeaturesData;
